export default __webpack_public_path__ + "static/ibac-762f477f519cdeb21eca37ac019453ae.png";